import { render, staticRenderFns } from "./DamDetail.vue?vue&type=template&id=2f242bc6&scoped=true&"
import script from "./DamDetail.vue?vue&type=script&lang=js&"
export * from "./DamDetail.vue?vue&type=script&lang=js&"
import style0 from "./DamDetail.vue?vue&type=style&index=0&id=2f242bc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f242bc6",
  null
  
)

export default component.exports